/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".setting-btn.mat-button[_ngcontent-%COMP%]{white-space:normal;word-wrap:break-all}.help-text[_ngcontent-%COMP%]{top:5px}\n/*# sourceMappingURL=download-audit-dialog.component.css.map*/"];
export { styles as styles };
